import { Drawer, DrawerButtons, DrawerContent, DrawerFooter, DrawerHeader } from '@e2m-customer-portal/ui';
import { Button } from '@mui/material';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TargetPowerSchedulePanel } from './GasStorageSchedulePanel';
import { GasProductionDataType, GasStorageDataType } from 'domains/optimization-group/types';

interface GasStorageSidePanelProps {
  gasStorageData: GasStorageDataType;
  gasProductionData: GasProductionDataType;
  open: boolean;
  onClose: () => void;
}

function GasStorageSidePanel({ gasStorageData, gasProductionData, open, onClose }: Readonly<GasStorageSidePanelProps>) {
  const [t] = useTranslation();
  const [showSchedule, setShowSchedule] = useState(false);

  useEffect(() => {
    if (!open) {
      setShowSchedule(false);
    }
  }, [open]);
  return (
    <>
      <TargetPowerSchedulePanel
        open={showSchedule}
        setOpen={setShowSchedule}
        targetPowerElectric={gasProductionData.target_power_electric}
      />
      <Drawer open={open} onClose={onClose} testId={``} disableEnforceFocus customWidth={350}>
        <DrawerHeader cancelLabel={t('SHARED_CANCEL')} noDivider></DrawerHeader>
        <DrawerContent className="pt-2" unknownErrorLabel={t('SHARED_ERROR_UNKNOWN')}>
          <Button variant="outlined" color="primary" onClick={() => setShowSchedule(!showSchedule)}>
            {t('Zeitplan für flexible Gasproduktion erstellen')}
          </Button>
        </DrawerContent>
        <DrawerFooter testId="forecast-assistant-footer">
          <DrawerButtons
            onCancel={onClose}
            onSave={() => {}}
            isLoading={false}
            disableSave={false}
            cancelLabel={t('SHARED_CANCEL')}
            saveLabel={t('SHARED_SUBMIT')}
          />
        </DrawerFooter>
      </Drawer>
    </>
  );
}

export default GasStorageSidePanel;
